/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * NinjaAPI
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
    ApplicationStatusResponseApiType,
    AuthorizeApplicationRequestApiType,
    AuthorizeApplicationSuccessResponseApiType,
    BankAccountConnectionRequestType,
    BankAccountResponseType,
    BorrowerDetailSchema,
    CertificateOfInsuranceDownloadResponseSchema,
    ChangeEmailRequestType,
    ChangePaymentMethodGetPadAgreementRequestSchema,
    ChangePaymentMethodGetPadAgreementResponseSchema,
    ChangePaymentMethodLinkAccountRequestSchema,
    ChangePaymentMethodLinkBankAccountResponseSchema,
    CheckBankAccountStatusResponseType,
    DefaultSuccessResponseSchema,
    DisbursalHistoryResponseSchema,
    DocumentDownloadResponseSchema,
    DocumentHistoryResponseSchema,
    EmailConsentRequestType,
    EmploymentInfoRequestType,
    FlinksPaymentCheckRequestSchema,
    FlinksPaymentCheckResponseSchema,
    FlinksSetAccountRequestSchema,
    FlinksTrackEventRequestSchema,
    LOSDocumentResponseApiType,
    LanguagePreferenceRequestApiType,
    LanguagePreferenceSchema,
    LoanPurposeRequestType,
    LoanQueryResponseSchema,
    MakePaymentRequestSchema,
    MakePaymentResponseSchema,
    ManualPaymentDetailResponseSchema,
    OfferDataResponseApiType,
    OfferTermRequestType,
    OnfidoTokenRequestApiType,
    OnfidoTokenResponseApiType,
    OriginationApiSaveLanguagePreference204,
    OriginationApiSavePaymentProtectionSelection204,
    OriginationApiUpdatePiiData204,
    OriginationApiUserCompletedOnfidoWorkflow204,
    OriginationOnboardingStepsResponseApiType,
    PartnerConfigRequestSchema,
    PartnerConfigResponseSchema,
    PaymentBreakdownRequestSchema,
    PaymentBreakdownResponseSchema,
    PaymentDeferralCompleteRequestSchema,
    PaymentDeferralCompleteResponseSchema,
    PaymentDeferralGetDeferralFormResponseSchema,
    PaymentDeferralProcessSelectedDateRequestSchema,
    PaymentDeferralProcessSelectedDateResponseSchema,
    PaymentDeferralValidationResponseSchema,
    PaymentDetailResponseSchema,
    PaymentProtectionDataResponseApiType,
    PaymentProtectionSelectionRequestApiType,
    PaymentProtectionSelectionRequestType,
    PaymentScheduleChangeCompleteRequestSchema,
    PaymentScheduleChangeProcessSelectedDateRequestSchema,
    PaymentScheduleChangeProcessSelectedDateResponseSchema,
    PaymentScheduleChangeValidationResponseSchema,
    PaymentScheduleRequestType,
    PaymentScheduleValidationRequestSchema,
    PersonalLoansV2ApiOfferChangeOfferEmail200,
    PersonalLoansV2ApiOfferGetOfferData200,
    PhoneNumberRequestType,
    PrequalificationAffiliateResponse,
    PrequalificationEmbeddedResponse,
    PrequalificationRequest,
    PrequalificationValidationEmailRequest,
    PrequalificationValidationPhoneNumberRequest,
    PrequalificationValidationResponse,
    ProfileSettingsUpdateRequestSchema,
    QCConsentRequestType,
    QueryParamsRequestType,
    QuerySessionRequestApiType,
    QuerySessionResponseApiType,
    RepaymentScheduleResponseSchema,
    ReviewDataResponseApiType,
    SessionTrackingInfoRequestType,
    SuccessSchema,
    TransactionHistoryResponseSchema,
    UpdatePiiDataRequestApiType,
    V3ApplicationRepaymentScheduleRequestType,
    V3ApplicationRepaymentScheduleResponseType
} from './api.schemas'

export const getNinjaAPI = () => {
    /**
 * Retrieve detailed information about a borrower based on the provided loan ID.

Args:
    request: The HTTP request object containing authentication details.
Returns:
    tuple: A tuple containing the HTTP status code and a dictionary with borrower details.
Raises:
    NinjaApiError: If there is an error parsing the Salesforce response.
The returned dictionary contains the following keys:
    - borrower_id (str): The ID of the borrower.
    - first_name (str): The first name of the borrower.
    - last_name (str): The last name of the borrower.
    - phone (str): The mobile phone number of the borrower.
    - email (str): The email address of the borrower.
    - complete_address (str): The complete address of the borrower.
    - billing_street (str): The billing street address of the borrower.
    - billing_city (str): The billing city of the borrower.
    - billing_state (str): The billing state of the borrower.
    - billing_country (str): The billing country of the borrower.
    - billing_postal_code (str): The billing postal code of the borrower.
    - language_preference (str): The language preference of the borrower.
 * @summary Get Borrower Detail
 */
    const portalApiGetBorrowerDetail = <TData = AxiosResponse<BorrowerDetailSchema>>(options?: AxiosRequestConfig): Promise<TData> => {
        return axios.get(`/v1/portal/borrower_detail`, options)
    }

    /**
 * Retrieves loan information for a given borrower from Salesforce by performing a SOQL query.

Args:
    request: The request object containing authentication and borrower information.

Returns:
    A tuple containing the HTTP status code and a dictionary with loan information.

Raises:
    NinjaApiError: If the borrower is not found, there is a loan query error, no record is found, or there is a parse error.
 * @summary Get Loan Detail
 */
    const portalApiGetLoanDetail = <TData = AxiosResponse<LoanQueryResponseSchema>>(options?: AxiosRequestConfig): Promise<TData> => {
        return axios.get(`/v1/portal/loan`, options)
    }

    /**
     * @summary Get Loan Repayment Schedule
     */
    const portalApiGetLoanRepaymentSchedule = <TData = AxiosResponse<RepaymentScheduleResponseSchema[]>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/repayment_schedule`, options)
    }

    /**
     * @summary Get Loan Transaction History
     */
    const portalApiGetLoanTransactionHistory = <TData = AxiosResponse<TransactionHistoryResponseSchema[]>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/transaction_history`, options)
    }

    /**
     * @summary Get Disbursal History
     */
    const portalApiGetDisbursalHistory = <TData = AxiosResponse<DisbursalHistoryResponseSchema[]>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/disbursal_history`, options)
    }

    /**
     * @summary Make Payment
     */
    const portalApiMakePayment = <TData = AxiosResponse<MakePaymentResponseSchema>>(
        loanId: string,
        makePaymentRequestSchema: MakePaymentRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/make_payment`, makePaymentRequestSchema, options)
    }

    /**
     * @summary Get Document History
     */
    const portalApiGetDocumentHistory = <TData = AxiosResponse<DocumentHistoryResponseSchema[]>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/documents`, options)
    }

    /**
     * @summary Download Document
     */
    const portalApiDownloadDocument = <TData = AxiosResponse<DocumentDownloadResponseSchema>>(
        loanId: string,
        documentId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/document/${documentId}/download`, options)
    }

    /**
     * @summary Get Payment Detail
     */
    const portalApiGetPaymentDetail = <TData = AxiosResponse<PaymentDetailResponseSchema[]>>(loanId: string, options?: AxiosRequestConfig): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/payment_detail`, options)
    }

    /**
     * @summary Get Manual Payment Detail
     */
    const portalApiGetManualPaymentDetail = <TData = AxiosResponse<ManualPaymentDetailResponseSchema>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/manual_payment_detail`, options)
    }

    /**
     * @summary Get Payment Breakdown
     */
    const portalApiGetPaymentBreakdown = <TData = AxiosResponse<PaymentBreakdownResponseSchema>>(
        loanId: string,
        paymentBreakdownRequestSchema: PaymentBreakdownRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/payment_breakdown`, paymentBreakdownRequestSchema, options)
    }

    /**
     * @summary Flinks Set Account
     */
    const portalApiFlinksSetAccount = <TData = AxiosResponse<DefaultSuccessResponseSchema>>(
        flinksSetAccountRequestSchema: FlinksSetAccountRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/flinks/set-account`, flinksSetAccountRequestSchema, options)
    }

    /**
 * This endpoint is used to track flinks events to help debug issues. Silently fails as we don't want this to
block the user.
 * @summary Flinks Track
 */
    const portalApiFlinksTrack = <TData = AxiosResponse<DefaultSuccessResponseSchema>>(
        flinksTrackEventRequestSchema: FlinksTrackEventRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/flinks/track`, flinksTrackEventRequestSchema, options)
    }

    /**
 * This API is used for checking whether or not the applicant has successfully
saved and linked their flinks payment method.
 * @summary Flinks Payment Check
 */
    const portalApiFlinksPaymentCheck = <TData = AxiosResponse<FlinksPaymentCheckResponseSchema>>(
        flinksPaymentCheckRequestSchema: FlinksPaymentCheckRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/flinks/payment-check`, flinksPaymentCheckRequestSchema, options)
    }

    /**
     * @summary Change Payment Method Link Bank Account
     */
    const portalApiChangePaymentMethodLinkBankAccount = <TData = AxiosResponse<ChangePaymentMethodLinkBankAccountResponseSchema>>(
        loanId: string,
        changePaymentMethodLinkAccountRequestSchema: ChangePaymentMethodLinkAccountRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/change_payment_method/link_bank_account`, changePaymentMethodLinkAccountRequestSchema, options)
    }

    /**
     * @summary Change Payment Method Get Pad Agreement
     */
    const portalApiChangePaymentMethodGetPadAgreement = <TData = AxiosResponse<ChangePaymentMethodGetPadAgreementResponseSchema>>(
        loanId: string,
        changePaymentMethodGetPadAgreementRequestSchema: ChangePaymentMethodGetPadAgreementRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/change_payment_method/get_pad_agreement`, changePaymentMethodGetPadAgreementRequestSchema, options)
    }

    /**
     * @summary Payment Schedule Change Validate Schedule
     */
    const portalApiPaymentScheduleChangeValidateSchedule = <TData = AxiosResponse<PaymentScheduleChangeValidationResponseSchema>>(
        loanId: string,
        paymentScheduleValidationRequestSchema: PaymentScheduleValidationRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/payment_schedule_change/validate_schedule`, paymentScheduleValidationRequestSchema, options)
    }

    /**
     * @summary Payment Schedule Change Process Selected Date
     */
    const portalApiPaymentScheduleChangeProcessSelectedDate = <TData = AxiosResponse<PaymentScheduleChangeProcessSelectedDateResponseSchema>>(
        loanId: string,
        paymentScheduleChangeProcessSelectedDateRequestSchema: PaymentScheduleChangeProcessSelectedDateRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(
            `/v1/portal/loan/${loanId}/payment_schedule_change/process_selected_date`,
            paymentScheduleChangeProcessSelectedDateRequestSchema,
            options
        )
    }

    /**
     * @summary Payment Schedule Change Complete
     */
    const portalApiPaymentScheduleChangeComplete = <TData = AxiosResponse<SuccessSchema>>(
        loanId: string,
        paymentScheduleChangeCompleteRequestSchema: PaymentScheduleChangeCompleteRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/payment_schedule_change/complete`, paymentScheduleChangeCompleteRequestSchema, options)
    }

    /**
     * @summary Payment Deferral Validate Schedule
     */
    const portalApiPaymentDeferralValidateSchedule = <TData = AxiosResponse<PaymentDeferralValidationResponseSchema>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/payment_deferral/validate_schedule`, undefined, options)
    }

    /**
     * @summary Payment Deferral Process Selected Date
     */
    const portalApiPaymentDeferralProcessSelectedDate = <TData = AxiosResponse<PaymentDeferralProcessSelectedDateResponseSchema>>(
        loanId: string,
        paymentDeferralProcessSelectedDateRequestSchema: PaymentDeferralProcessSelectedDateRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/payment_deferral/process_selected_date`, paymentDeferralProcessSelectedDateRequestSchema, options)
    }

    /**
     * @summary Payment Deferral Complete
     */
    const portalApiPaymentDeferralComplete = <TData = AxiosResponse<PaymentDeferralCompleteResponseSchema>>(
        loanId: string,
        paymentDeferralCompleteRequestSchema: PaymentDeferralCompleteRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/payment_deferral/complete`, paymentDeferralCompleteRequestSchema, options)
    }

    /**
     * @summary Payment Deferral Get Deferral Form
     */
    const portalApiPaymentDeferralGetDeferralForm = <TData = AxiosResponse<PaymentDeferralGetDeferralFormResponseSchema>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/loan/${loanId}/payment_deferral/get_deferral_form`, undefined, options)
    }

    /**
     * @summary Payment Schedule Change Get Pad Agreement
     */
    const portalApiPaymentScheduleChangeGetPadAgreement = <TData = AxiosResponse<DocumentDownloadResponseSchema>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/payment_schedule_change/get_pad_agreement`, options)
    }

    /**
     * @summary Payment Protection Get Certificate Of Insurance
     */
    const portalApiPaymentProtectionGetCertificateOfInsurance = <TData = AxiosResponse<CertificateOfInsuranceDownloadResponseSchema>>(
        loanId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/payment_protection/get_certificate_of_insurance`, options)
    }

    /**
     * This API is used to save a borrower's language preference.
     * @summary Save Language Preference
     */
    const portalApiSaveLanguagePreference = <TData = AxiosResponse<SuccessSchema>>(
        languagePreferenceSchema: LanguagePreferenceSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/save_language_preference`, languagePreferenceSchema, options)
    }

    /**
     * @summary Profile Settings Update
     */
    const portalApiProfileSettingsUpdate = <TData = AxiosResponse<DefaultSuccessResponseSchema>>(
        profileSettingsUpdateRequestSchema: ProfileSettingsUpdateRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/profile_settings/update`, profileSettingsUpdateRequestSchema, options)
    }

    /**
     * @summary Profile Settings Email Changed
     */
    const portalApiProfileSettingsEmailChanged = <TData = AxiosResponse<DefaultSuccessResponseSchema>>(
        emailUid: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/portal/profile_settings/email_changed/${emailUid}`, undefined, options)
    }

    /**
     * @summary Unsubscribe
     */
    const portalApiUnsubscribe = <TData = AxiosResponse<SuccessSchema>>(guid: string, options?: AxiosRequestConfig): Promise<TData> => {
        return axios.post(`/v1/portal/unsubscribe/${guid}`, undefined, options)
    }

    /**
     * @summary Check Can Delay Payment
     */
    const portalApiCheckCanDelayPayment = <TData = AxiosResponse<SuccessSchema>>(loanId: string, options?: AxiosRequestConfig): Promise<TData> => {
        return axios.get(`/v1/portal/loan/${loanId}/payment_deferral/can_delay_payment`, options)
    }

    /**
 * Create an embedded prequalification request.

Args:
    request (HttpRequest): Request with partner_id injected by auth.
    payload (PrequalificationRequest): Borrower/application data.
Returns:
    dict[str, Any]: Response payload matching PrequalificationEmbeddedResponse schema.
 * @summary Create Prequalification Request
 */
    const personalLoansV2ApiPrequalificationCreatePrequalificationRequest = <TData = AxiosResponse<PrequalificationEmbeddedResponse>>(
        prequalificationRequest: PrequalificationRequest,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/personal_loans_v2/prequal`, prequalificationRequest, options)
    }

    /**
     * @summary Create Affiliate Prequalification Request
     */
    const personalLoansV2ApiPrequalificationCreateAffiliatePrequalificationRequest = <TData = AxiosResponse<PrequalificationAffiliateResponse>>(
        prequalificationRequest: PrequalificationRequest,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/personal_loans_v2/e2e/prequal`, prequalificationRequest, options)
    }

    /**
 * Validate the provided phone number for prequalification.

This endpoint checks if the given phone number is already associated with an existing user
in the system. If a duplicate is found, an appropriate error response is returned.
Otherwise, the phone number is considered valid for use in a new prequalification request.

Args:
    request: The HTTP request object, containing authentication and partner context.
    payload: PrequalificationValidationPhoneNumberRequest containing the phone number to validate.

Returns:
    PrequalificationValidationResponse if the phone number is valid and not a duplicate.
    ErrorApiType with an appropriate error message if the phone number is already in use.
 * @summary Prequalification Validation Phone Number
 */
    const personalLoansV2ApiPrequalificationPrequalificationValidationPhoneNumber = <TData = AxiosResponse<PrequalificationValidationResponse>>(
        prequalificationValidationPhoneNumberRequest: PrequalificationValidationPhoneNumberRequest,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/personal_loans_v2/validation/phone_number`, prequalificationValidationPhoneNumberRequest, options)
    }

    /**
 * Validate the provided email for prequalification.

This endpoint checks if the given email is already associated with an existing user
in the system. If a duplicate is found, an appropriate error response is returned.
Otherwise, the email is considered valid for use in a new prequalification request.

Args:
    request: The HTTP request object, containing authentication and partner context.
    payload: PrequalificationValidationEmailRequest containing the email to validate.

Returns:
    PrequalificationValidationResponse if the email is valid and not a duplicate.
    ErrorApiType with an appropriate error message if the email is already in use.
 * @summary Prequalification Validation Email
 */
    const personalLoansV2ApiPrequalificationPrequalificationValidationEmail = <TData = AxiosResponse<PrequalificationValidationResponse>>(
        prequalificationValidationEmailRequest: PrequalificationValidationEmailRequest,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/personal_loans_v2/validation/email`, prequalificationValidationEmailRequest, options)
    }

    /**
     * Get partner configuration and return encoded partner_id.
     * @summary Partner Configuration
     */
    const personalLoansV2ApiPartnerConfigurationPartnerConfiguration = <TData = AxiosResponse<PartnerConfigResponseSchema>>(
        partnerConfigRequestSchema: PartnerConfigRequestSchema,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/personal_loans_v2/e2e/partner-config`, partnerConfigRequestSchema, options)
    }

    /**
     * This API is used for getting the offer data for the application.
     * @summary Offer Detail
     */
    const originationApiOfferDetail = <TData = AxiosResponse<OfferDataResponseApiType>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/origination/${applicationId}/offer_detail`, options)
    }

    /**
     * Return the ordered origination onboarding steps for this application.
     * @summary Onboarding Steps
     */
    const originationApiOnboardingSteps = <TData = AxiosResponse<OriginationOnboardingStepsResponseApiType>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/origination/${applicationId}/onboarding_steps`, options)
    }

    /**
     * This API is used for saving the applicant's selected loan term and amount.
     * @summary Save Offer Term
     */
    const originationApiSaveOfferTerm = <TData = AxiosResponse<void>>(
        applicationId: string,
        offerTermRequestType: OfferTermRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_offer_term`, offerTermRequestType, options)
    }

    /**
     * This API is used for saving the applicant's payment schedule.
     * @summary Save Payment Schedule
     */
    const originationApiSavePaymentSchedule = <TData = AxiosResponse<void>>(
        applicationId: string,
        paymentScheduleRequestType: PaymentScheduleRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_payment_schedule`, paymentScheduleRequestType, options)
    }

    /**
     * This API is used for saving the applicant's employment information.
     * @summary Save Employment Info
     */
    const originationApiSaveEmploymentInfo = <TData = AxiosResponse<void>>(
        applicationId: string,
        employmentInfoRequestType: EmploymentInfoRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_employment_info`, employmentInfoRequestType, options)
    }

    /**
 * This API is used for saving the applicant's phone number.
Expects a 10-digit phone number with no separators (e.g., "1234567890").

Returns 400 Bad Request if:
    • offer or application is not found
    • phone number format is invalid
 * @summary Save Phone Number
 */
    const originationApiSavePhoneNumber = <TData = AxiosResponse<void>>(
        applicationId: string,
        phoneNumberRequestType: PhoneNumberRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_phone_number`, phoneNumberRequestType, options)
    }

    /**
     * This API is used for saving the applicant's email consent.
     * @summary Save Email Consent
     */
    const originationApiSaveEmailConsent = <TData = AxiosResponse<void>>(
        applicationId: string,
        emailConsentRequestType: EmailConsentRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_email_consent`, emailConsentRequestType, options)
    }

    /**
     * This API is used for saving the applicant's loan purpose.
     * @summary Save Loan Purpose
     */
    const originationApiSaveLoanPurpose = <TData = AxiosResponse<void>>(
        applicationId: string,
        loanPurposeRequestType: LoanPurposeRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_loan_purpose`, loanPurposeRequestType, options)
    }

    /**
     * This API is used for saving the applicant's QC consent.
     * @summary Save Qc Consent
     */
    const originationApiSaveQcConsent = <TData = AxiosResponse<void>>(
        applicationId: string,
        qCConsentRequestType: QCConsentRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_qc_consent`, qCConsentRequestType, options)
    }

    /**
     * This API is used for generating the applicant's Onfido SDK token.
     * @summary Generate Onfido Sdk Token
     */
    const originationApiGenerateOnfidoSdkToken = <TData = AxiosResponse<OnfidoTokenResponseApiType>>(
        applicationId: string,
        onfidoTokenRequestApiType: OnfidoTokenRequestApiType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/generate_onfido_sdk_token`, onfidoTokenRequestApiType, options)
    }

    /**
     * This API is used for updating the applicant's Onfido workflow status to user action completed.
     * @summary User Completed Onfido Workflow
     */
    const originationApiUserCompletedOnfidoWorkflow = <TData = AxiosResponse<OriginationApiUserCompletedOnfidoWorkflow204>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/user_completed_onfido_workflow`, undefined, options)
    }

    /**
     * This API is used for generating the loan agreement and PAD documents for the application.
     * @summary Generate Pdf Documents
     */
    const originationApiGeneratePdfDocuments = <TData = AxiosResponse<LOSDocumentResponseApiType>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/origination/${applicationId}/generate_pdf_documents`, options)
    }

    /**
     * This API is used for getting the review data for the application.
     * @summary Get Review Data
     */
    const originationApiGetReviewData = <TData = AxiosResponse<ReviewDataResponseApiType>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/origination/${applicationId}/get_review_data`, options)
    }

    /**
     * This API is used for getting the application status for the application.
     * @summary Get Application Status
     */
    const originationApiGetApplicationStatus = <TData = AxiosResponse<ApplicationStatusResponseApiType>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/origination/${applicationId}/get_application_status`, options)
    }

    /**
     * This API is used for updating the PII data for the application.
     * @summary Update Pii Data
     */
    const originationApiUpdatePiiData = <TData = AxiosResponse<OriginationApiUpdatePiiData204>>(
        applicationId: string,
        updatePiiDataRequestApiType: UpdatePiiDataRequestApiType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/update_pii_data`, updatePiiDataRequestApiType, options)
    }

    /**
 * This API is used for saving the applicant's language preference.
Language preference:
- en: English
- fr: French
 * @summary Save Language Preference
 */
    const originationApiSaveLanguagePreference = <TData = AxiosResponse<OriginationApiSaveLanguagePreference204>>(
        applicationId: string,
        languagePreferenceRequestApiType: LanguagePreferenceRequestApiType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_language_preference`, languagePreferenceRequestApiType, options)
    }

    /**
     * This API is used for authorizing the application.
     * @summary Authorize Application
     */
    const originationApiAuthorizeApplication = <TData = AxiosResponse<AuthorizeApplicationSuccessResponseApiType>>(
        applicationId: string,
        authorizeApplicationRequestApiType: AuthorizeApplicationRequestApiType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/authorize`, authorizeApplicationRequestApiType, options)
    }

    /**
 * This API is used for querying the TMX session.
This is currently being triggered on the Onfido step of the application.
A prior TMX profile call must be made first before this can be called. (Currently done on the offer page)
This will trigger TMX to parse the profile call and return a score to determine if the applicant is a high risk applicant.
 * @summary Query Tmx Session
 */
    const originationApiQueryTmxSession = <TData = AxiosResponse<QuerySessionResponseApiType>>(
        applicationId: string,
        querySessionRequestApiType: QuerySessionRequestApiType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/query_session`, querySessionRequestApiType, options)
    }

    /**
     * This API is used for getting the payment protection data for the application.
     * @summary Retrieve Payment Protection Data
     */
    const originationApiRetrievePaymentProtectionData = <TData = AxiosResponse<PaymentProtectionDataResponseApiType>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/origination/${applicationId}/payment_protection_data`, options)
    }

    /**
     * This API is used for saving the applicant's payment protection selection.
     * @summary Save Payment Protection Selection
     */
    const originationApiSavePaymentProtectionSelection = <TData = AxiosResponse<OriginationApiSavePaymentProtectionSelection204>>(
        applicationId: string,
        paymentProtectionSelectionRequestApiType: PaymentProtectionSelectionRequestApiType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_payment_protection_selection`, paymentProtectionSelectionRequestApiType, options)
    }

    /**
     * This API is used for saving the applicant's payment protection selection.
     * @summary Save Payment Protection
     */
    const originationApiSavePaymentProtection = <TData = AxiosResponse<void>>(
        applicationId: string,
        paymentProtectionSelectionRequestType: PaymentProtectionSelectionRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_payment_protection`, paymentProtectionSelectionRequestType, options)
    }

    /**
 * This API is used for initiating a bank account connection.

This endpoint is called after the user has completed the Flinks flow in the frontend.

The next step is to wait for the Flinks webhook response to be processed in the flinks_get_account_detail function.

- Creates a BankAccount object in the database in preparation for the Flinks webhook response to be processed.
- Returns a 201 success response if successful.
 * @summary Bank Account Connect
 */
    const originationApiBankAccountConnect = <TData = AxiosResponse<BankAccountResponseType | BankAccountResponseType>>(
        bankAccountConnectionRequestType: BankAccountConnectionRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/bank_account/connect`, bankAccountConnectionRequestType, options)
    }

    /**
 * This API is used for checking the status of a bank account connection.

This endpoint is called after the user has completed the Flinks flow in the frontend, and has landed on the loading page.

- Checks if the bank account connection is complete, is declined, or has an error by checking the BankAccount object in the database by user and flinks_account_id.

- Returns a 200 success response if successful.
- Returns a 404 error if the bank account is not found.
 * @summary Bank Account Status
 */
    const originationApiBankAccountStatus = <TData = AxiosResponse<CheckBankAccountStatusResponseType>>(
        flinksAccountId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/origination/bank_account/${flinksAccountId}/status`, options)
    }

    /**
 * Force-complete a bank account verification for testing environments only.
Sets all status fields to PASS and marks the bank account as complete.
 * @summary Bank Account Force Complete
 */
    const originationApiBankAccountForceComplete = <TData = AxiosResponse<CheckBankAccountStatusResponseType>>(
        bankAccountId: number,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/bank_account/${bankAccountId}/force-complete`, undefined, options)
    }

    /**
 * This API is used for generating the repayment schedule for the application.
loan_amount is read from the persisted Application record to prevent stale frontend values.
 * @summary Generate Repayment Schedule
 */
    const originationApiGenerateRepaymentSchedule = <TData = AxiosResponse<V3ApplicationRepaymentScheduleResponseType>>(
        applicationId: string,
        v3ApplicationRepaymentScheduleRequestType: V3ApplicationRepaymentScheduleRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/generate_repayment_schedule`, v3ApplicationRepaymentScheduleRequestType, options)
    }

    /**
 * This API is used for saving the applicant's query params.
No authentication is required.
 * @summary Save Query Params
 */
    const originationApiSaveQueryParams = <TData = AxiosResponse<void>>(
        applicationId: string,
        queryParamsRequestType: QueryParamsRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_query_params`, queryParamsRequestType, options)
    }

    /**
     * This API is used for saving the applicant's partner session tracking info.
     * @summary Save Session Tracking Info
     */
    const originationApiSaveSessionTrackingInfo = <TData = AxiosResponse<void>>(
        applicationId: string,
        sessionTrackingInfoRequestType: SessionTrackingInfoRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/origination/${applicationId}/save_session_tracking_info`, sessionTrackingInfoRequestType, options)
    }

    /**
     * @summary Get Offer Data
     */
    const personalLoansV2ApiOfferGetOfferData = <TData = AxiosResponse<PersonalLoansV2ApiOfferGetOfferData200>>(
        applicationId: string,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.get(`/v1/personal_loans_v2/offer/${applicationId}`, options)
    }

    /**
     * @summary Change Email
     */
    const personalLoansV2ApiOfferChangeOfferEmail = <TData = AxiosResponse<PersonalLoansV2ApiOfferChangeOfferEmail200>>(
        applicationId: string,
        changeEmailRequestType: ChangeEmailRequestType,
        options?: AxiosRequestConfig
    ): Promise<TData> => {
        return axios.post(`/v1/personal_loans_v2/offer/${applicationId}/change_email`, changeEmailRequestType, options)
    }

    return {
        portalApiGetBorrowerDetail,
        portalApiGetLoanDetail,
        portalApiGetLoanRepaymentSchedule,
        portalApiGetLoanTransactionHistory,
        portalApiGetDisbursalHistory,
        portalApiMakePayment,
        portalApiGetDocumentHistory,
        portalApiDownloadDocument,
        portalApiGetPaymentDetail,
        portalApiGetManualPaymentDetail,
        portalApiGetPaymentBreakdown,
        portalApiFlinksSetAccount,
        portalApiFlinksTrack,
        portalApiFlinksPaymentCheck,
        portalApiChangePaymentMethodLinkBankAccount,
        portalApiChangePaymentMethodGetPadAgreement,
        portalApiPaymentScheduleChangeValidateSchedule,
        portalApiPaymentScheduleChangeProcessSelectedDate,
        portalApiPaymentScheduleChangeComplete,
        portalApiPaymentDeferralValidateSchedule,
        portalApiPaymentDeferralProcessSelectedDate,
        portalApiPaymentDeferralComplete,
        portalApiPaymentDeferralGetDeferralForm,
        portalApiPaymentScheduleChangeGetPadAgreement,
        portalApiPaymentProtectionGetCertificateOfInsurance,
        portalApiSaveLanguagePreference,
        portalApiProfileSettingsUpdate,
        portalApiProfileSettingsEmailChanged,
        portalApiUnsubscribe,
        portalApiCheckCanDelayPayment,
        personalLoansV2ApiPrequalificationCreatePrequalificationRequest,
        personalLoansV2ApiPrequalificationCreateAffiliatePrequalificationRequest,
        personalLoansV2ApiPrequalificationPrequalificationValidationPhoneNumber,
        personalLoansV2ApiPrequalificationPrequalificationValidationEmail,
        personalLoansV2ApiPartnerConfigurationPartnerConfiguration,
        originationApiOfferDetail,
        originationApiOnboardingSteps,
        originationApiSaveOfferTerm,
        originationApiSavePaymentSchedule,
        originationApiSaveEmploymentInfo,
        originationApiSavePhoneNumber,
        originationApiSaveEmailConsent,
        originationApiSaveLoanPurpose,
        originationApiSaveQcConsent,
        originationApiGenerateOnfidoSdkToken,
        originationApiUserCompletedOnfidoWorkflow,
        originationApiGeneratePdfDocuments,
        originationApiGetReviewData,
        originationApiGetApplicationStatus,
        originationApiUpdatePiiData,
        originationApiSaveLanguagePreference,
        originationApiAuthorizeApplication,
        originationApiQueryTmxSession,
        originationApiRetrievePaymentProtectionData,
        originationApiSavePaymentProtectionSelection,
        originationApiSavePaymentProtection,
        originationApiBankAccountConnect,
        originationApiBankAccountStatus,
        originationApiBankAccountForceComplete,
        originationApiGenerateRepaymentSchedule,
        originationApiSaveQueryParams,
        originationApiSaveSessionTrackingInfo,
        personalLoansV2ApiOfferGetOfferData,
        personalLoansV2ApiOfferChangeOfferEmail
    }
}
export type PortalApiGetBorrowerDetailResult = AxiosResponse<BorrowerDetailSchema>
export type PortalApiGetLoanDetailResult = AxiosResponse<LoanQueryResponseSchema>
export type PortalApiGetLoanRepaymentScheduleResult = AxiosResponse<RepaymentScheduleResponseSchema[]>
export type PortalApiGetLoanTransactionHistoryResult = AxiosResponse<TransactionHistoryResponseSchema[]>
export type PortalApiGetDisbursalHistoryResult = AxiosResponse<DisbursalHistoryResponseSchema[]>
export type PortalApiMakePaymentResult = AxiosResponse<MakePaymentResponseSchema>
export type PortalApiGetDocumentHistoryResult = AxiosResponse<DocumentHistoryResponseSchema[]>
export type PortalApiDownloadDocumentResult = AxiosResponse<DocumentDownloadResponseSchema>
export type PortalApiGetPaymentDetailResult = AxiosResponse<PaymentDetailResponseSchema[]>
export type PortalApiGetManualPaymentDetailResult = AxiosResponse<ManualPaymentDetailResponseSchema>
export type PortalApiGetPaymentBreakdownResult = AxiosResponse<PaymentBreakdownResponseSchema>
export type PortalApiFlinksSetAccountResult = AxiosResponse<DefaultSuccessResponseSchema>
export type PortalApiFlinksTrackResult = AxiosResponse<DefaultSuccessResponseSchema>
export type PortalApiFlinksPaymentCheckResult = AxiosResponse<FlinksPaymentCheckResponseSchema>
export type PortalApiChangePaymentMethodLinkBankAccountResult = AxiosResponse<ChangePaymentMethodLinkBankAccountResponseSchema>
export type PortalApiChangePaymentMethodGetPadAgreementResult = AxiosResponse<ChangePaymentMethodGetPadAgreementResponseSchema>
export type PortalApiPaymentScheduleChangeValidateScheduleResult = AxiosResponse<PaymentScheduleChangeValidationResponseSchema>
export type PortalApiPaymentScheduleChangeProcessSelectedDateResult = AxiosResponse<PaymentScheduleChangeProcessSelectedDateResponseSchema>
export type PortalApiPaymentScheduleChangeCompleteResult = AxiosResponse<SuccessSchema>
export type PortalApiPaymentDeferralValidateScheduleResult = AxiosResponse<PaymentDeferralValidationResponseSchema>
export type PortalApiPaymentDeferralProcessSelectedDateResult = AxiosResponse<PaymentDeferralProcessSelectedDateResponseSchema>
export type PortalApiPaymentDeferralCompleteResult = AxiosResponse<PaymentDeferralCompleteResponseSchema>
export type PortalApiPaymentDeferralGetDeferralFormResult = AxiosResponse<PaymentDeferralGetDeferralFormResponseSchema>
export type PortalApiPaymentScheduleChangeGetPadAgreementResult = AxiosResponse<DocumentDownloadResponseSchema>
export type PortalApiPaymentProtectionGetCertificateOfInsuranceResult = AxiosResponse<CertificateOfInsuranceDownloadResponseSchema>
export type PortalApiSaveLanguagePreferenceResult = AxiosResponse<SuccessSchema>
export type PortalApiProfileSettingsUpdateResult = AxiosResponse<DefaultSuccessResponseSchema>
export type PortalApiProfileSettingsEmailChangedResult = AxiosResponse<DefaultSuccessResponseSchema>
export type PortalApiUnsubscribeResult = AxiosResponse<SuccessSchema>
export type PortalApiCheckCanDelayPaymentResult = AxiosResponse<SuccessSchema>
export type PersonalLoansV2ApiPrequalificationCreatePrequalificationRequestResult = AxiosResponse<PrequalificationEmbeddedResponse>
export type PersonalLoansV2ApiPrequalificationCreateAffiliatePrequalificationRequestResult = AxiosResponse<PrequalificationAffiliateResponse>
export type PersonalLoansV2ApiPrequalificationPrequalificationValidationPhoneNumberResult = AxiosResponse<PrequalificationValidationResponse>
export type PersonalLoansV2ApiPrequalificationPrequalificationValidationEmailResult = AxiosResponse<PrequalificationValidationResponse>
export type PersonalLoansV2ApiPartnerConfigurationPartnerConfigurationResult = AxiosResponse<PartnerConfigResponseSchema>
export type OriginationApiOfferDetailResult = AxiosResponse<OfferDataResponseApiType>
export type OriginationApiOnboardingStepsResult = AxiosResponse<OriginationOnboardingStepsResponseApiType>
export type OriginationApiSaveOfferTermResult = AxiosResponse<void>
export type OriginationApiSavePaymentScheduleResult = AxiosResponse<void>
export type OriginationApiSaveEmploymentInfoResult = AxiosResponse<void>
export type OriginationApiSavePhoneNumberResult = AxiosResponse<void>
export type OriginationApiSaveEmailConsentResult = AxiosResponse<void>
export type OriginationApiSaveLoanPurposeResult = AxiosResponse<void>
export type OriginationApiSaveQcConsentResult = AxiosResponse<void>
export type OriginationApiGenerateOnfidoSdkTokenResult = AxiosResponse<OnfidoTokenResponseApiType>
export type OriginationApiUserCompletedOnfidoWorkflowResult = AxiosResponse<OriginationApiUserCompletedOnfidoWorkflow204>
export type OriginationApiGeneratePdfDocumentsResult = AxiosResponse<LOSDocumentResponseApiType>
export type OriginationApiGetReviewDataResult = AxiosResponse<ReviewDataResponseApiType>
export type OriginationApiGetApplicationStatusResult = AxiosResponse<ApplicationStatusResponseApiType>
export type OriginationApiUpdatePiiDataResult = AxiosResponse<OriginationApiUpdatePiiData204>
export type OriginationApiSaveLanguagePreferenceResult = AxiosResponse<OriginationApiSaveLanguagePreference204>
export type OriginationApiAuthorizeApplicationResult = AxiosResponse<AuthorizeApplicationSuccessResponseApiType>
export type OriginationApiQueryTmxSessionResult = AxiosResponse<QuerySessionResponseApiType>
export type OriginationApiRetrievePaymentProtectionDataResult = AxiosResponse<PaymentProtectionDataResponseApiType>
export type OriginationApiSavePaymentProtectionSelectionResult = AxiosResponse<OriginationApiSavePaymentProtectionSelection204>
export type OriginationApiSavePaymentProtectionResult = AxiosResponse<void>
export type OriginationApiBankAccountConnectResult = AxiosResponse<BankAccountResponseType | BankAccountResponseType>
export type OriginationApiBankAccountStatusResult = AxiosResponse<CheckBankAccountStatusResponseType>
export type OriginationApiBankAccountForceCompleteResult = AxiosResponse<CheckBankAccountStatusResponseType>
export type OriginationApiGenerateRepaymentScheduleResult = AxiosResponse<V3ApplicationRepaymentScheduleResponseType>
export type OriginationApiSaveQueryParamsResult = AxiosResponse<void>
export type OriginationApiSaveSessionTrackingInfoResult = AxiosResponse<void>
export type PersonalLoansV2ApiOfferGetOfferDataResult = AxiosResponse<PersonalLoansV2ApiOfferGetOfferData200>
export type PersonalLoansV2ApiOfferChangeOfferEmailResult = AxiosResponse<PersonalLoansV2ApiOfferChangeOfferEmail200>
